import RequestForm from './RequestForm.vue';

export * from './types';
export default RequestForm;



// WEBPACK FOOTER //
// ./src/pages/vacancies/form/components/requestform/index.ts